export var Target;
(function (Target) {
    Target["SELF"] = "_self";
    Target["BLANK"] = "_blank";
})(Target || (Target = {}));
export var LinkTheme;
(function (LinkTheme) {
    LinkTheme["DARK"] = "dark";
    LinkTheme["LIGHT"] = "Light";
})(LinkTheme || (LinkTheme = {}));
export var LinkAppearance;
(function (LinkAppearance) {
    LinkAppearance["NAVIGATION_BAR"] = "navigation-bar";
    LinkAppearance["BACK_TO_RCM"] = "back-to-rcm";
    LinkAppearance["DEFAULT_LINK_STYLE"] = "default-link-style";
    LinkAppearance["FOOTER"] = "footer";
    LinkAppearance["TEXT"] = "text";
    LinkAppearance["CONTAINED_PRIMARY"] = "contained-primary";
    LinkAppearance["BACK_HEADER"] = "back-header";
    LinkAppearance["OUTLINE_WHITE"] = "outline-white";
    LinkAppearance["LEGAL_TEXT"] = "legal-text";
    LinkAppearance["RESET"] = "reset";
    LinkAppearance["ERROR_PAGE"] = "error-page";
})(LinkAppearance || (LinkAppearance = {}));
export var SlotPosition;
(function (SlotPosition) {
    SlotPosition["LEFT"] = "left";
    SlotPosition["RIGHT"] = "right";
})(SlotPosition || (SlotPosition = {}));
//# sourceMappingURL=oh-link.types.js.map
